import React from 'react';
import Acord28Form from './Acord28Form';
import type { Acord28FormRef } from './Acord28Form';
import type { StoredCoverage, StoredPolicy } from '../../utils/parseAcord28StoredCoverages';

export type { Acord28FormRef };

interface Acord28With101FormProps {
  selectedPolicies?: string[];
  selectedProperties?: string[];
  insuredId?: string;
  fileParentId?: string;
  editCoverages?: StoredCoverage[];
  editPolicies?: StoredPolicy[];
}

const Acord28With101Form = React.forwardRef<Acord28FormRef, Acord28With101FormProps>(
  function Acord28With101Form({ selectedPolicies = [], selectedProperties = [], insuredId = '', fileParentId, editCoverages, editPolicies }, ref) {
    return <Acord28Form ref={ref} showAcord101 selectedPolicies={selectedPolicies} selectedProperties={selectedProperties} insuredId={insuredId} fileParentId={fileParentId} editCoverages={editCoverages} editPolicies={editPolicies} />;
  }
);

export default Acord28With101Form;
